<button id="btnPicker"
    [style.background]="color ? color : colorDefecto">
</button>